import React from 'react';

export default function Header({ user, onProfileClick, showBack }) {
  return (
    <header className="header" style={{ position: 'relative' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', paddingBottom: 8, position: 'relative', zIndex: 1 }}>

        {/* Spacer left */}
        <div style={{ width: 48, flexShrink: 0 }} />

        {/* Logo centered */}
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4 }}>
          <img
            src="/logo.png"
            alt="Bethesda Español"
            style={{ height: 52, width: 'auto', objectFit: 'contain' }}
          />
          {user && !user.isAnonymous && (
            <p style={{ fontSize: '0.75rem', color: 'rgba(255,255,255,0.55)', marginTop: 2 }}>
              Bienvenido, {user.displayName?.split(' ')[0]} 👋
            </p>
          )}
        </div>

        {/* Profile button right — vertically centered with logo */}
        <button
          onClick={onProfileClick}
          style={{
            background: 'rgba(255,255,255,0.12)',
            border: '1.5px solid rgba(255,255,255,0.2)',
            borderRadius: '50%',
            width: 48, height: 48,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            cursor: 'pointer', padding: 0, overflow: 'hidden', flexShrink: 0,
          }}
        >
          {showBack ? (
            <span style={{ fontSize: '1.2rem', color: 'white' }}>🏠</span>
          ) : user?.photoURL && !user?.isAnonymous ? (
            <img src={user.photoURL} alt="Profile" style={{ width: 48, height: 48, borderRadius: '50%', objectFit: 'cover' }} />
          ) : (
            <span style={{ fontSize: '1.1rem' }}>👤</span>
          )}
        </button>

      </div>
    </header>
  );
}
